export const FRIEND_MODAL = 'FRIEND_MODAL'
export const WINK_MODAL = 'WINK_MODAL'
export const GALLERY_MODAL = 'GALLERY_MODAL'
export const UPLOAD_PHOTO_MODAL = 'UPLOAD_PHOTO_MODAL'
export const MESSAGE_MODAL = 'MESSAGE_MODAL'
export const CONFIRM_EMAIL_MODAL = 'CONFIRM_EMAIL_MODAL'
export const PROFILE_UPDATE_MODAL = 'PROFILE_UPDATE_MODAL'
export const FLAG_SETTER_MODAL = 'FLAG_SETTER_MODAL'
